import React from 'react';
import '../Address/Address.css';



function Address(props) {
  return (
    <a href={props.href} target='_blank' title={props.name}>
        <div className='address-box'>
            <div className='icon-div' id={props.bg}>
                <i className={props.icon}></i>
            </div>
            <div className='text'>
                <h4>{props.h4}</h4>
                <span>{props.span2}</span>
            </div>
         </div>
    </a>
    
  )
}

export default Address;